// client/src/utils/structureTypes.js
// Итерация 8.3c: определение типа локации (structure/surface/system).
// Используется в GameClient (useStructureInfo) и Navigator (resolveContext).
//
// ⚠️ Чистые функции — без React, без window.

const STRUCTURE_TYPES = new Set([
  'station',
  'space_station',
  'ship',
  'shipyard',
  'spaceport',
  'civil_structure',
  'structure',
  'military_structure',
]);

const SURFACE_TYPES = new Set(['planet', 'moon', 'asteroid', 'surface']);

const SYSTEM_TYPES = new Set(['system', 'star_system', 'deep_space']);

export function isStructureType(type) {
  if (!type) return false;
  return STRUCTURE_TYPES.has(String(type).toLowerCase());
}

export function isSurfaceType(type) {
  if (!type) return false;
  return SURFACE_TYPES.has(String(type).toLowerCase());
}

export function isSystemType(type) {
  if (!type) return false;
  return SYSTEM_TYPES.has(String(type).toLowerCase());
}

export { STRUCTURE_TYPES, SURFACE_TYPES, SYSTEM_TYPES };
